import { useState, useCallback } from 'react'
import { Network, MessageCircle } from 'lucide-react'
import { KgVisualization } from '../components/kg/KgVisualization'
import type { SelectedNodeInfo } from '../components/kg/KgVisualization'
import { useDoctrineMode } from '../hooks/useDoctrineMode'
import { LiteModeNotice } from '../components/LiteModeNotice'

export function KgBrowserPage() {
  const { isLite, isFeatureAvailable } = useDoctrineMode()
  const [, setSelectedNodes] = useState<SelectedNodeInfo[]>([])

  const handleSelectionChange = useCallback((nodes: SelectedNodeInfo[]) => {
    setSelectedNodes(nodes)
  }, [])

  const openChat = useCallback(() => {
    window.dispatchEvent(new KeyboardEvent('keydown', { key: 'k', metaKey: true }))
  }, [])

  if (isLite && !isFeatureAvailable('knowledge-graph')) {
    return <LiteModeNotice feature="Knowledge Graph" />
  }

  return (
    <div className="flex flex-col h-[calc(100vh-4rem)] p-4 gap-4">
      {/* Header */}
      <div className="flex items-center justify-between flex-shrink-0">
        <div className="flex items-center gap-3">
          <Network className="w-6 h-6 text-blue-500" />
          <h1 className="text-xl font-bold text-gray-900 dark:text-white">Knowledge Graph</h1>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={openChat}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 border border-gray-300 dark:border-gray-600 rounded-lg hover:border-blue-400 transition-colors"
            title="Open chat (Cmd+K)"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">Chat</span>
            <kbd className="hidden sm:inline text-[10px] px-1 py-0.5 bg-gray-100 dark:bg-gray-700 rounded">&#8984;K</kbd>
          </button>
        </div>
      </div>

      {/* Graph */}
      <div className="flex-1 min-h-0">
        <KgVisualization
          scope="portfolio"
          entityIds={[]}
          height="100%"
          onSelectionChange={handleSelectionChange}
          onAskAboutSelection={openChat}
        />
      </div>
    </div>
  )
}
